module.exports = __webpack_public_path__ + "static/media/Group9237.b2a65067.png";